'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = canPotentiallySelect;
exports.canPotentiallySelectDeliveryTypeNow = canPotentiallySelectDeliveryTypeNow;
exports.canPotentiallySelectAnyDeliveryType = canPotentiallySelectAnyDeliveryType;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Restaurant = require('../Restaurant');

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _Maybe = require('../../Maybe');

var _Maybe2 = _interopRequireDefault(_Maybe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//By delivery/takeout status object (from wixrest-utils)
function canPotentiallySelect(deliveryMethod, organization, moment) {
    if (!deliveryMethod) return false;

    if (deliveryMethod.available || deliveryMethod.preorder) return true;

    if (_lodash2.default.get(organization, 'orders.future.disabled')) {
        return false;
    }

    var diffMins = moment(deliveryMethod.until).diff(moment(), 'minutes');

    return diffMins > 0 && diffMins <= _lodash2.default.get(organization, 'orders.future.delayMins.max');
}

//By deliveryType String
function canPotentiallySelectDeliveryTypeNow(deliveryType, organization, moment) {
    var status = _Restaurant2.default.getDeliveryOptions({
        restaurant: organization,
        cal: moment().tz(organization.timezone)
    });

    return canPotentiallySelect(status[deliveryType], organization, moment);
}

function canPotentiallySelectAnyDeliveryType(organization, moment) {
    var canSelectDelivery = canPotentiallySelectDeliveryTypeNow('delivery', organization, moment);

    var canSelectTakeout = canPotentiallySelectDeliveryTypeNow('takeout', organization, moment);

    var canSelectPremises = canPotentiallySelectDeliveryTypeNow('premises', organization, moment);

    return canSelectDelivery || canSelectTakeout || canSelectPremises;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/FutureDelivery/DeliveryMethodsHelper.js
// module id = 398
// module chunks = 0